<div class="user-icon" *ngFor="let participant of participants">
	<div class="word-avatar" style.background-color="#{{participant.user.bgColor}}" (click)="userInfoOp.toggle($event)">
		<div class="short-name">
			{{participant.user.shortCode}}
		</div>
	</div>

	<p-overlayPanel #userInfoOp appendTo="body" styleClass="user-info-op">
		<app-user-info-popup [participant]="participant"></app-user-info-popup>
	</p-overlayPanel>
</div>
<div class="user-icon">
	<div class="word-avatar blank" style.background-color="#f3f3f3" (click)="addUserOp.toggle($event)">
		<div class="short-name">
			+
		</div>
	</div>
	<p-overlayPanel #addUserOp appendTo="body" styleClass="user-info-op">
		<app-add-user-popup></app-add-user-popup>
	</p-overlayPanel>
</div>